"use strict";
var DefaultSortHandler = (function () {
    function DefaultSortHandler(defaultSortOptions) {
        this.fieldSortType = "Field";
        this.defaultSortOptions = defaultSortOptions;
    }
    DefaultSortHandler.prototype.addSortCriteriaToQuery = function (queryBuilder) {
        queryBuilder.sortCriteria = this.defaultSortOptions.defaultSortCriteriaLowercase;
        if (this.defaultSortOptions.defaultSortType === this.fieldSortType) {
            queryBuilder.sortField = this.defaultSortOptions.defaultSortField;
        }
    };
    return DefaultSortHandler;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = DefaultSortHandler;



//////////////////
// WEBPACK FOOTER
// ./Base/Sorts/DefaultSortHandler.js
// module id = 7
// module chunks = 0